var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'footer-copyright':!_vm.$route.path.includes('Extern'), 'atBottom':_vm.$route.path.includes('Extern') }},[_c('div',{class:{'zentriert':!_vm.$route.path.includes('Extern')}},[_c('router-link',{attrs:{"to":"/kontakt"}},[_vm._v("Impressum")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }